export default __webpack_public_path__ + "static/prof-bsp-2d89e0eefadeff36f2b474307a5428f1.png";